module.exports = __webpack_public_path__ + "static/Renee baltine-8772d1de299321e80e10e5ce7345573b.png";